module.exports = __webpack_public_path__ + "img/liste.4c7ea73f.png";